import { render, staticRenderFns } from "./MultiDataMatrixReader.vue?vue&type=template&id=23edf94e&scoped=true&"
import script from "./MultiDataMatrixReader.vue?vue&type=script&lang=js&"
export * from "./MultiDataMatrixReader.vue?vue&type=script&lang=js&"
import style0 from "./MultiDataMatrixReader.vue?vue&type=style&index=0&id=23edf94e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23edf94e",
  null
  
)

export default component.exports